"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/PGFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_182)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_182`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24.0003H-6V0Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 -0.000244141H30V23.9997",
					fill: "#A2001D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.38817 16.9561L8.58238 17.554H9.21104L8.70247 17.9235L8.89674 18.5213L8.38817 18.1519L7.8796 18.5213L8.0738 17.9235L7.56523 17.554H8.19383L8.38817 16.9561ZM6.78265 11.217L7.10644 12.2135H8.15417L7.30648 12.8292L7.63027 13.8257L6.78265 13.2098L5.93504 13.8257L6.2589 12.8292L5.41121 12.2135H6.45894L6.78265 11.217ZM6.78265 18.5213L7.10637 19.5179H8.15417L7.30641 20.1336L7.63027 21.1301L6.78265 20.5143L5.93504 21.1301L6.25876 20.1336L5.41121 19.5179H6.45879L6.78265 18.5213ZM9.84589 13.8257L10.1698 14.8222H11.2175L10.3698 15.438L10.6936 16.4344L9.84589 15.8186L8.99834 16.4344L9.3222 15.438L8.47452 14.8222H9.52224L9.84589 13.8257ZM3.71935 13.8257L4.04321 14.8222H5.09079L4.24325 15.438L4.56689 16.4344L3.71935 15.8186L2.87173 16.4344L3.19552 15.438L2.3479 14.8222H3.39556L3.71935 13.8257Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.4745 8.35533C19.9382 7.81899 19.2414 7.50223 18.4925 7.44774L20.734 5.70434C19.8412 4.81151 18.6448 4.40841 17.4772 4.49369C17.3332 3.97484 17.0571 3.50219 16.6759 3.12183L15.7905 4.89272C15.7311 4.78432 15.6566 4.68495 15.5691 4.59762C15.0597 4.0882 14.2338 4.08827 13.7246 4.59762C13.2153 5.10696 13.2152 5.93285 13.7246 6.4422C13.8119 6.5296 13.9113 6.60412 14.0197 6.66354L12.2488 7.54899C12.6293 7.93033 13.1021 8.20648 13.6212 8.35048C13.5356 9.51809 13.9384 10.7143 14.8312 11.6071L16.7897 9.08918C16.9357 8.9445 17.1331 8.86354 17.3386 8.86404C17.5477 8.86404 17.7442 8.94547 17.892 9.09326C17.9649 9.16576 18.0227 9.25199 18.062 9.34698C18.1014 9.44196 18.1215 9.54381 18.1212 9.64662C18.1212 9.85573 18.0398 10.0522 17.892 10.2L18.6299 10.9378C18.9747 10.593 19.1647 10.1343 19.1647 9.64662C19.1647 9.2476 19.0375 8.86819 18.8024 8.55439C19.1559 8.64842 19.4782 8.83428 19.7367 9.09312C20.5504 9.90678 20.5504 11.2308 19.7367 12.0445L20.4746 12.7824C21.0658 12.1911 21.3914 11.4049 21.3914 10.5688C21.3913 9.73268 21.0657 8.94659 20.4745 8.35533Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_182`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as PGFlag };
